import { merge } from 'lodash';

const BASE_EXTERNA_CABECALHO = [
  'Id_SEQ_INC',
  'Id_AIS',
  'Cd_CC',
  'CD_ODI',
  'CD_SubODI',
  'Nr_TI',
  'Nr_CM',
  'Nr_TUC',
  'Nr_A1',
  'Nr_A2',
  'Nr_A3',
  'Nr_A4',
  'Nr_A5',
  'Nr_A6',
  'Cd_UAR',
  'Cd_UC',
  'Cd_Patrim',
  'Cd_DIG_INC',
  'COD_ITEM',
  'Qtd_AIS',
  'Cd_UND_AIS',
  'VL_VOC',
  'Dt_Imob',
  'VL_DEP_ACUM',
  'VL_VOC_VF',
  'VL_VOC_COM',
  'VL_VOC_CA',
  'VL_VOC_JOA',
  'VL_VOC_VF_AVAL',
  'VL_VOC_COM_AVAL',
  'VL_VOC_CA_AVAL',
  'VL_VOC_JOA_AVAL',
  'Cd_ODD',
  'Dt_BX',
  'Txt_DESC_TECN',
  'Txt_CLS_TNS',
  'FLG_RSV',
  'Cd_ODI_ENG',
  'Cd_TP_AVAL',
  'Cd_SISBASE',
  'Id_BP',
  'TP_BEM',
  'VL_VNR_UC',
  'VL_IAI_UC',
  'VL_DAC_UC',
  'VL_VMU_UC',
  'VL_IAD_UC',
  'VL_VBR_UC',
  'VL_100DEP_UC',
  'Pct_IA',
  'VL_VNR_VF_UNIT',
  'VL_VNR_COM_UNIT',
  'VL_VNR_CA_UNIT',
  'VL_VNR_JOA',
  'FLG_DOA_OE',
  'FLG_INCOR_OE',
  'FLG_PLPT_OE',
  'FLG_OAT',
  'FLG_REG',
  'FLG_ELIG',
  'Cd_CONC',
  'Cd_ABCC',
  'Cd_NumFIS',
  'Dt_REF_DADOS',
  'Dt_CNTB_AJST'
];

const initialState = {
  titulo: '',
  arquivoBaseExterna: {
    id: '',
    fileObj: undefined,
    delimitador: ';',
    involucro: '"',
    escape: '\\',
    cabecalho: BASE_EXTERNA_CABECALHO,
    uploading: false
  },
  simulacaoLaudoIncremental: {
    id: null,
    nome: ''
  },
  parametros: {
    testesValidacao: []
  }
};

const state = initialState;

const getters = {};

const actions = {
  setValidadorLaudos({ commit }, value) {
    commit('SET_VALIDADOR_LAUDOS', value);
  },
  clearValidadorLaudos({ commit }) {
    commit('CLEAR_VALIDADOR_LAUDOS', initialState);
  }
};

const mutations = {
  SET_VALIDADOR_LAUDOS: (state, value) => (state = merge(state, value)),
  CLEAR_VALIDADOR_LAUDOS: (state, value) => {
    state = merge(state, value);
    state.arquivoBaseExterna.fileObj = undefined;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
